import ReadMoreContainer from "../ReadMoreContainer";

export default function KKEBrugervejlening() {
  return (
    <div className="row mb-6">
      <div className="col-12 col-xl-9">
        <ReadMoreContainer maxLength={6}>
          <h2 className="display-4 fw-semibold" style={{ fontSize: "1.2rem" }}>
            Brugervejledning
          </h2>
          <ol className="my-3 ps-4">
            <li>
              <p className="ms-2 mb-2">
                I højre kolonne vises status for udfyldelse af erklæringen, og
                hvornår ændringer sidst er gemt.
              </p>
            </li>
            <li>
              <p className="ms-2 mb-2">
                Fanen ”Advokatens oplysninger” skal være fuldstændig udfyldt,
                før fanen ”Revisors erklæring” kan udfyldes.
              </p>
            </li>
            <li>
              <p className="ms-2 mb-2">
                Revisor får adgang til at udfylde og godkende erklæringen, ved
                at advokaten logger ind, og kopierer og mailer et link til
                erklæringen til revisor. Linket kan også videresendes internt
                til f.eks. en bogholder. Klik på ”Invitér”.
              </p>
            </li>
            <li>
              <p className="ms-2 mb-2">
                Husk at klikke på ”Gem ændringer”, inden du forlader siden, hvis
                du ønsker at gemme det, der er indtastet. Du skal også klikke på
                ”Gem ændringer”, inden du klikker på ”Godkend med MitID”.
              </p>
            </li>
            <li>
              <p className="ms-2 mb-2">
                Ved at klikke på ”Forhåndsvisning” kan advokat og revisor se den
                samlede erklæring, som den ser ud med de oplysninger, der indtil
                videre er indtastet. Den foreløbige erklæring kan evt.
                downloades og printes til eget brug.
              </p>
            </li>
            <li>
              <p className="ms-2 mb-2">
                Erklæringen bliver først sendt til Advokatsamfundet, når den er
                godkendt med MitID af både en advokat og revisor. Rækkefølgen af
                godkendelser er underordnet. Som advokat kan du kun godkende
                erklæringen med MitID, når du er logget ind med samme MitID, og
                som revisor skal du bruge linket for at godkende med MitID.{" "}
              </p>
            </li>
            <li>
              <p className="ms-2 mb-2">
                Advokat og revisor modtager en kvitteringsmail med den samlede
                erklæring i forbindelse med indsendelsen, hvis advokat og
                revisor har indtastet en mailadresse til brug herfor.
              </p>
            </li>
          </ol>
        </ReadMoreContainer>
      </div>
    </div>
  );
}
